import { render, staticRenderFns } from "./DownloadContent.vue?vue&type=template&id=5c553100&scoped=true&lang=pug&"
import script from "./DownloadContent.vue?vue&type=script&lang=ts&"
export * from "./DownloadContent.vue?vue&type=script&lang=ts&"
import style0 from "./DownloadContent.vue?vue&type=style&index=0&id=5c553100&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c553100",
  null
  
)

export default component.exports